(function () {
  function initBlogSidebar() {
    document.querySelectorAll('[data-blog-sidebar-toggle]').forEach(function (button) {
      if (button.dataset.blogSidebarBound) return;
      button.dataset.blogSidebarBound = 'true';

      button.addEventListener('click', function () {
        var panel = button.closest('[data-blog-sidebar-panel]');
        var body = panel && panel.querySelector('[data-blog-sidebar-body]');
        if (!body) return;

        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        body.classList.toggle('is-collapsed', expanded);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogSidebar);
  } else {
    initBlogSidebar();
  }

  document.addEventListener('shopify:section:load', initBlogSidebar);
})();
